import React, { Fragment, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Typography, Dialog, DialogTitle, DialogContent, DialogActions, Button } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { useTheme } from '@mui/material/styles';
import {
    ListItem, ListItemAvatar, ListItemSecondaryAction,
    ListItemText, Link, Avatar, IconButton,
} from '@mui/material';
import { styled } from '@mui/material/styles';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';

import Icon from '@mdi/react'
import {
    mdiPin, mdiPinOff, mdiPentagon,
    mdiPencil, mdiDelete
} from '@mdi/js';

import {
    addToPinnedZone, removeFromPinnedZone,
    setZoneDetailView, removeZoneDetailView,
    removeMarkerDetailView, zoneDetailViewSelector, editZone, deleteZone
} from '../../features/places/placesSlice';
import { resetFindLatLng, setMapControl, setNeedBounding } from '../../features/map/mapSlice';
const useStyles = makeStyles((theme) => ({
    active: {
        backgroundColor: 'LightYellow'
    },
    inactive: {
        backgroundColor: 'White'
    }

}));

const LightTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: useTheme().palette.common.white,
        color: 'rgba(0, 0, 0, 0.87)',
        boxShadow: useTheme().shadows[1],
        fontSize: 11,
    },
}));


const ZoneListItem = ({ zoneId, pinned, setListViewCallback }) => {
    const classes = useStyles();
    const dispatch = useDispatch();
    const zoneDetailView = useSelector(zoneDetailViewSelector);

    const zoneData = useSelector(state => state.places.zones[`${zoneId}`]);
    const [confirmOpen, setConfirmOpen] = useState(false);

    const togglePinned = () => {
        if (pinned) {
            dispatch(removeFromPinnedZone(zoneId));
        } else {
            dispatch(addToPinnedZone(zoneId));
        }
    }

    const toggleDetailView = () => {
        if (zoneId === zoneDetailView) {
            dispatch(removeZoneDetailView());
            dispatch(setMapControl('asset'));
        } else {
            dispatch(removeMarkerDetailView());
            dispatch(resetFindLatLng());
            dispatch(setZoneDetailView(zoneId));
            dispatch(setMapControl('zone'));
            dispatch(setNeedBounding(true));
        }
    }

    const handleDeleteZone = () => {
        setConfirmOpen(true);
    }

    const confirmDeleteZone = () => {
        dispatch(deleteZone(zoneId));
        setConfirmOpen(false);
    }

    const handleZoneEdit = () => {
        dispatch(editZone(zoneData));
        setListViewCallback('zoneCreate');
    }

    return (
        <Fragment>
            <ListItem
                className={zoneId === zoneDetailView ? classes.active : classes.inactive}
            >
                <ListItemAvatar>
                    <Avatar style={{ backgroundColor: 'white' }}>
                        <Icon
                            path={mdiPentagon}
                            title="ZoneIcon"
                            size={1}
                            color={zoneData.zone_color}
                        />
                    </Avatar>
                </ListItemAvatar>
                <ListItemText
                    primary={
                        <Link href="#" onClick={toggleDetailView}>
                            <Typography variant="subtitle2" color='textPrimary'>
                                <span>
                                    <b>
                                        {zoneData.zone_name}
                                    </b>
                                </span>
                            </Typography>
                        </Link>
                    }
                    secondary={zoneData ? zoneData.zone_tags ? zoneData.zone_tags.length <= 1 ?
                        <Typography variant="subtitle2">{zoneData.zone_tags[0]}</Typography>
                        :
                        <LightTooltip title={zoneData.zone_tags.join(", ")}>
                            <Typography variant="subtitle2" >{zoneData.zone_tags[0]} + {zoneData.zone_tags.length - 1}</Typography>
                        </LightTooltip >

                        : null : null}
                />
                <ListItemSecondaryAction>

                    <IconButton onClick={handleZoneEdit} size="large">
                        <Icon
                            path={mdiPencil}
                            title="Zone Edit"
                            size={0.7}
                            color="DodgerBlue"
                        />
                    </IconButton>
                    <IconButton onClick={handleDeleteZone} size="large">
                        <Icon
                            path={mdiDelete}
                            title="Zone Delete"
                            size={0.7}
                            color="Crimson"
                        />
                    </IconButton>
                    <IconButton onClick={togglePinned} size="large">
                        {
                            pinned ?
                                <Icon
                                    path={mdiPin}
                                    title="ZonePin"
                                    size={0.7}
                                    color="SlateBlue"
                                />
                                :
                                <Icon
                                    path={mdiPinOff}
                                    title="ZonePin"
                                    size={0.7}
                                    color="Grey"
                                />
                        }
                    </IconButton>

                </ListItemSecondaryAction>

            </ListItem>
            <Dialog
                open={confirmOpen}
                onClose={() => setConfirmOpen(false)}
                maxWidth="xs"
                fullWidth
            >
                <DialogTitle>Delete Zone</DialogTitle>
                <DialogContent>
                    <Typography variant="body2">
                        Delete zone <b>{zoneData?.zone_name || 'this zone'}</b>? This action cannot be undone.
                    </Typography>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setConfirmOpen(false)}>Cancel</Button>
                    <Button onClick={confirmDeleteZone} color="error" variant="contained">
                        Delete
                    </Button>
                </DialogActions>
            </Dialog>
        </Fragment>
    );
}

export default ZoneListItem;
